<div class="flex flex-col space-y-6 h-full relative">
  <div *ngFor="let step of steps; let i = index" class="mb-0">
    <div class="relative flex flex-col mb-0" [ngClass]="{
        'pb-10': !step.subSteps?.length || !isExpanded(i),
        'pb-6': step.subSteps?.length && isExpanded(i)
    }" #stepContainer>

      <!-- Step Header -->
      <div class="flex items-center space-x-2">
        <div #stepCircle
          class="flex items-center justify-center xl:w-10 xl:h-10 h-8 w-8 rounded-full font-medium transition-all duration-200 text-white text-xl shrink-0"
          [ngClass]="{
            'bg-(--brand-primary)': i + 1 <= currentStep,
            'bg-gray-400': i + 1 > currentStep
          }">
          {{ i + 1 }}
        </div>

        <div class="flex items-center justify-between w-full">
          <span class="text-base font-medium" [ngClass]="{
              'text-(--text-primary)': i + 1 <= currentStep,
              'text-gray-500': i + 1 > currentStep
            }">
            {{ step.label | translate }}
          </span>

          <button *ngIf="step.subSteps?.length"
            class="hover:opacity-90 rounded-full border border-(--brand-primary) cursor-pointer xl:w-8 xl:h-8 w-6 h-6 flex justify-center items-center transition shrink-0"
            (click)="toggleStepExpansion(i)">
            <img src="assets/icons/arrow-down.svg" alt="Arrow" class="w-3 h-3 transition"
              [ngClass]="{ 'rotate-180': isExpanded(i) }" />
          </button>
        </div>
      </div>

      <!-- Muted Full Connector -->
      <div *ngIf="i < steps.length - 1"
        class="absolute top-12 w-1 rounded-full left-4 rtl:right-4 rtl:left-auto transition-all duration-300"
        [ngStyle]="{ height: getConnectorHeightFromDOM(i), 'background-color': 'var(--color-muted)' }"></div>

      <!-- Blue Progress Overlay -->
      <div *ngIf="i < steps.length - 1 && getProgressHeight(i) !== '0px'"
        class="absolute top-12 w-1 rounded-full left-4 rtl:right-4 rtl:left-auto transition-all duration-300"
        [ngStyle]="{ height: getProgressHeight(i), 'background-color': 'var(--brand-primary)' }"></div>

      <!-- Substeps -->
      <div *ngIf="step.subSteps?.length && isExpanded(i)"
        class="substeps rtl:mr-14 rtl:ml-0 ml-14 mt-3 flex flex-col space-y-4 relative">
        <ng-container *ngFor="let subStep of step.subSteps; let j = index">
          <div class="substep text-base cursor-pointer pl-4" [ngClass]="{
  'text-(--text-primary)': i + 1 < currentStep || (i + 1 === currentStep && j + 1 <= currentSubStep),
  'text-gray-400': i + 1 > currentStep || (i + 1 === currentStep && j + 1 > currentSubStep),
  'font-medium': i + 1 === currentStep && j + 1 === currentSubStep,
  'font-normal': !(i + 1 === currentStep && j + 1 === currentSubStep)
}">
            {{ subStep.label | translate }}
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>